import Typography from "components/common/Typography";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import EventForm from "../EventForm";

import { useEventForm } from "./hooks";

const NewEvent: FC = () => {
  const eventForm = useEventForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create event" />
        </Typography.Title>
      </Header>
      <EventForm {...eventForm} />
    </>
  );
};

export default NewEvent;
